import Container = PIXI.Container;
import Graphics = PIXI.Graphics;
import { Stack } from './Stack';
import { SceneManager } from '../managers/SceneManager';
import { createSprite } from '../../utils/GameEngine';
import { animateIdle, clearAnimations } from '../../utils/Animations';

export class BaseTutorial {
  private overlay: PIXI.Graphics;
  private tutorialHand: PIXI.Sprite;
  private step: number = 1;

  constructor(private stage: Container, private destStack: Stack, private originStack: Stack) {

  }

  public nextStep(): void {
    switch (this.step) {
      case 1: {
        this.firstStep();
        this.step++;
        break;
      }
      case 2: {
        this.secondStep();
        this.step++;
        break;
      }
      case 3: {
        this.thirdStep();
        this.step++;
        break;
      }
    }
  }

  private firstStep(): void {
    this.overlay = new Graphics();
    this.overlay.beginFill(0x000000);
    this.overlay.drawRect(0, 0, SceneManager.gameWidth, SceneManager.gameHeight);
    this.overlay.endFill();
    this.overlay.interactive = true;
    this.overlay.alpha = 0.7;
    this.stage.addChild(this.overlay);

    this.stage.addChild(this.destStack);
    this.tutorialHand = createSprite('hand_vector', this.stage);
    this.tutorialHand.anchor.set(0.5, 0.5);
    this.tutorialHand.scale.set(1.2, 1.2);
    this.tutorialHand.position.set(this.destStack.getOrigin().x, this.destStack.getOrigin().y);
    animateIdle(this.tutorialHand, 1.7);
  }

  private secondStep(): void {
    this.destStack.interactive = false;
    this.stage.addChild(this.originStack);
    this.stage.addChild(this.tutorialHand);
    TweenLite.to(this.tutorialHand, 0.3, {
      x: this.originStack.getOrigin().x,
      y: this.originStack.getOrigin().y
    });
  }

  private thirdStep(): void {
    this.overlay.visible = false;
    this.tutorialHand.visible = false;
    this.overlay.destroy();
    clearAnimations(this.tutorialHand);
    this.tutorialHand.destroy();
  }
}